<!-- 差分強調表示凡例 -->
<div *ngIf="isDel || isDiff" class="c-flex-float-list c-flex-float-list-emp-ex">
  <div class="p-sub-column-layout02-flex">
    <dl class="p-payment-detailes-summary-block">
      <span class="emph-ex"></span>
      <!-- WCAG規定により、凡例は読み上げ対象外 -->
      <span aria-hidden="true" [innerHTML]="'reader.diffIcon' | staticMsg"></span>
    </dl>
  </div>
</div>
<!-- サマリ本体 -->
<div class="c-flex-float-list" [ngClass]="{ 'delete-padding-top': isDel || isDiff }">
  <div class="p-sub-column-layout02-flex">
    <dl class="p-payment-detailes-summary-block">
      <div class="c-float-list01__item">
        <dt
          class="c-float-list01__title c-float-list01__title--em c-float-list01__contents--fs16 c-float-list01__title--gray90"
          [innerHTML]="'label.paymentTotalAmount' | staticMsg"
        ></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs24">
          <span class="u-font-24" [ngClass]="{ del: isDel, diff: isDiff }">
            <!-- 支払総額 -->
            <span [innerHTML]="data.totalAmount | amountFormat : undefined : data.currencyCode"></span>
            <span *ngIf="!isNone" class="u-visually-hidden" [innerHTML]="'reader.diffIcon' | staticMsg"></span>
          </span>
          <span *ngIf="isPromotion" class="u-visually-hidden" [innerHTML]="'label.afterApply' | staticMsg"></span>
        </dd>
      </div>
      <div *ngIf="isPromotion" class="c-float-list01__item">
        <dt class="c-float-list01__title"></dt>
        <dd class="c-float-list01__contents">
          <span class="u-font-20 u-weight-normal">
            <!-- プロモ適用前支払総額 -->
            <del [innerHTML]="data.originalTotal | amountFormat : undefined : data.currencyCode"></del>
          </span>
          <span *ngIf="isPromotion" class="u-visually-hidden" [innerHTML]="'label.beforeApply' | staticMsg"></span>
        </dd>
      </div>
      <div class="c-float-list01__item">
        <dt class="c-float-list01__title"><!--見出しなし--></dt>
        <!--搭乗者種別毎の人数 -->
        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
          {{ data.travelersSummaryStr }}
        </dd>
      </div>
      <div *ngIf="isPromotion" class="c-float-list01__item">
        <!-- プロモーションコード -->
        <dt class="c-float-list01__title" [innerHTML]="'label.applidPromotion' | staticMsg"></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
          {{ data.promotionCode }}
        </dd>
      </div>
    </dl>
  </div>
  <div class="p-sub-column-layout02-flex p-payment-detailes-line-sp-only">
    <dl class="p-payment-detailes-summary-block">
      <div *ngIf="!(isCanada && data.totalFlightSurcharge)" class="c-float-list01__item">
        <!-- 運賃総額 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.fare' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span
            class="c-float-list01__contents--fs16 u-weight-bold"
            [innerHTML]="data.totalFare | amountFormat : undefined : data.currencyCode"
          ></span>
        </dd>
      </div>
      <div *ngIf="isCanada && data.totalFlightSurcharge" class="c-float-list01__item">
        <!-- 運賃総額(フライトサーチャージ総額併記) -->
        <dt class="c-float-list01__title" [innerHTML]="'lable.fareAndVariousCharge' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span
            class="c-float-list01__contents--fs16 u-weight-bold"
            [innerHTML]="data.totalFare | amountFormat : undefined : data.currencyCode"
          ></span
          ><br />
          <span
            class="c-float-list01__contents--fs16 u-weight-bold"
            [innerHTML]="
              'label.parenthesis.n'
                | staticMsg : { '0': data.totalFlightSurcharge | amountFormat : undefined : data.currencyCode }
            "
          ></span>
        </dd>
      </div>
      <div *ngIf="isCanada" class="c-float-list01__item">
        <!-- 燃油特別付加運賃等 -->
        <dt class="c-float-list01__title" [innerHTML]="'lable.fuelSurcharge' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span
            class="c-float-list01__contents--fs16 u-weight-normal"
            [innerHTML]="data.airTransportationCharges | amountFormat : undefined : data.currencyCode"
          ></span>
        </dd>
      </div>
      <div *ngIf="!isCanada" class="c-float-list01__item">
        <!-- 税金総額 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.taxFare2' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span
            class="c-float-list01__contents--fs16 u-weight-normal"
            [innerHTML]="data.totalTax | amountFormat : undefined : data.currencyCode"
          ></span>
        </dd>
      </div>
      <div *ngIf="isCanada" class="c-float-list01__item">
        <!-- 各国諸税・空港使用料等 -->
        <dt class="c-float-list01__title" [innerHTML]="'lable.taxesFeeArges' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span
            class="c-float-list01__contents--fs16 u-weight-normal"
            [innerHTML]="data.thirdPartyCharges | amountFormat : undefined : data.currencyCode"
          ></span>
        </dd>
      </div>
      <div *ngIf="!isCanada" class="c-float-list01__item">
        <!-- 発券手数料 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.fee' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <!-- ※固定値0を出力 -->
          <span
            class="c-float-list01__contents--fs16 u-weight-normal"
            [innerHTML]="0 | amountFormat : undefined : data.currencyCode"
          ></span>
        </dd>
      </div>
    </dl>
    <div class="p-payment-detailes-summary-block p-payment-detailes-line">
      <dl class="c-float-list01">
        <div *ngIf="data.ancillaryTotalWithoutTax !== 0" class="c-float-list01__item">
          <!-- Ancillaryサービス税抜総額 -->
          <dt class="c-float-list01__title" [innerHTML]="'label.paidServiceCharges' | staticMsg"></dt>
          <dd class="c-float-list01__contents">
            <span
              class="c-float-list01__contents--fs16 u-weight-normal"
              [innerHTML]="data.ancillaryTotalWithoutTax | amountFormat : undefined : data.currencyCode"
            ></span>
          </dd>
        </div>
        <div *ngIf="data.ancillaryTotalTax !== 0" class="c-float-list01__item">
          <!-- Ancillaryサービス税金総額 -->
          <dt class="c-float-list01__title" [innerHTML]="'label.paidServiceTaxAmount' | staticMsg"></dt>
          <dd class="c-float-list01__contents">
            <span
              class="c-float-list01__contents--fs16 u-weight-normal"
              [innerHTML]="data.ancillaryTotalTax | amountFormat : undefined : data.currencyCode"
            ></span>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</div>

<div *ngIf="data.alertLabelTxt.length !== 0" class="p-alert-label-txt">
  <div *ngFor="let str of data.alertLabelTxt" class="p-alert-label-txt_content">
    <em class="p-alert-label-txt_content_txt" [innerHTML]="str | staticMsg"></em>
  </div>
</div>
